import styled from 'styled-components'

const StyledPage = styled.div`
  background-color: ${({ theme }) => theme.colors.grey};
  min-height: 100vh;
`

export default StyledPage
